import React from 'react';

const Vue_VFor_Components = () => {
  return (
    <div>
      <h1>Vue_VFor_Components Component</h1>
      <p>This is the Vue_VFor_Components tutorial page.</p>
    </div>
  );
}

export default Vue_VFor_Components;
